const locale = {
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    user: 'Usuario',
    account: 'Cuenta',
    signOut: 'Cerrar sesión',
    items: 'elementos',
    yes: 'Sí',
    no: 'No',
  },
  language: {
    label: 'Idioma',
    shortLabel: 'Idioma',
    options: {
      'pt-BR': 'Portugués (Brasil)',
      'en-US': 'Inglés (EE. UU.)',
      'es-ES': 'Español',
    },
  },
  table: {
    empty: 'No se encontraron registros',
    pagination: '{{start}}-{{end}} de {{total}} elementos',
  },
  modal: {
    ok: 'Guardar',
    cancel: 'Cancelar',
  },
  sideNav: {
    internalPanel: 'Panel interno',
    userMenu: {
      account: 'Cuenta',
      resetPassword: 'Restablecer contraseña',
      signOut: 'Cerrar sesión',
    },
    sections: {
      overview: 'Visión general',
      care: 'Atención',
      finance: 'Finanzas y convenios',
      admin: 'Administración',
    },
    menu: {
      home: 'Inicio',
      schedules: 'Citas',
      schedule: 'Agenda',
      scheduleStatus: 'Estado de agenda',
      holidays: 'Feriados',
      clients: 'Clientes / Proveedores',
      odontology: 'Odontología',
      treatments: 'Presupuestos / Tratamientos',
      healthCertificatesControl: 'Control de certificados',
      templates: 'Modelos',
      healthCertificates: 'Certificados',
      documentsControl: 'Control de documentos',
      documents: 'Documentos',
      prescriptionTemplates: 'Modelos de recetas',
      prescriptions: 'Recetas',
      formsControl: 'Control de historias clínicas',
      medicalRecords: 'Historias clínicas',
      procedures: 'Procedimientos',
      financial: 'Finanzas',
      financialPlan: 'Plan de cuentas',
      paymentMethods: 'Formas de pago',
      payableReceivable: 'Cuentas por pagar / cobrar',
      cashRegister: 'Control de caja',
      guidesControl: 'Control de guías',
      guideStatus: 'Estado de guía',
      guides: 'Guías',
      professionalsControl: 'Control de profesionales',
      specialties: 'Especialidades',
      terminologies: 'Terminologías',
      professionals: 'Profesionales',
      covenants: 'Convenios',
      usersControl: 'Control de usuarios',
      accessGroup: 'Grupo de acceso',
      users: 'Usuarios',
      salesControl: 'Control de ventas',
      productSales: 'Venta de productos',
      salesTracking: 'Seguimiento de ventas',
      inventoryControl: 'Control de inventario',
      productTypes: 'Tipos de producto',
      registerProducts: 'Registrar productos',
      inventoryBalance: 'Saldo de inventario',
      whatsapp: 'WhatsApp',
      connections: 'Conexiones',
      monitoring: 'Monitoreo',
      relationship: 'Relación (CRM)',
      crmCampaigns: 'Campañas',
      crmTemplates: 'Plantillas',
      crmMessaging: 'Bandeja / Mensajes',
      crcDashboard: 'Panel CRC',
      crcContacts: 'Central de Contactos',
      crcPendencies: 'Pendencias',
      crcReports: 'Informes',
      companyData: 'Datos de la empresa',
      companies: 'Empresas',
    },
  },
  auth: {
    clinicAccess: 'Acceso de la clínica',
    title: 'Bienvenido de nuevo',
    subtitle:
      'Complete los datos a continuación para acceder a la gestión de la clínica.',
    systemEntry: 'Entrar al sistema',
    panelDescription:
      'Gestión más simple para recepción, profesionales y gerentes en un solo sistema.',
    support: {
      clinicCodeTitle: 'Código de la clínica',
      clinicCodeDescription:
        'Identifica la unidad o empresa a la que va a acceder.',
      credentialsTitle: 'Usuario y contraseña',
      credentialsDescription: 'Use los datos registrados para su equipo.',
      secureAccessTitle: 'Acceso seguro',
      secureAccessDescription:
        'Sus datos quedan vinculados solo a la clínica informada.',
    },
    fields: {
      clinic: 'Código de la clínica',
      clinicExtra: 'Ejemplo: clinica-centro',
      clinicPlaceholder: 'Ingrese el código de la clínica',
      username: 'Usuario',
      usernamePlaceholder: 'Ingrese su usuario',
      password: 'Contraseña',
      passwordPlaceholder: 'Ingrese su contraseña',
    },
    validation: {
      clinicRequired: '¡Por favor informe el código de la clínica!',
      usernameRequired: '¡Por favor informe su usuario!',
      passwordRequired: '¡Por favor informe su contraseña!',
    },
    submit: 'Entrar al sistema',
    error: {
      title: 'Error de autenticación',
      description:
        'No fue posible entrar. Verifique el código de la clínica, el usuario y la contraseña.',
    },
  },
  resetPassword: {
    title: 'Restablecer contraseña',
    fields: {
      oldPassword: 'Contraseña actual',
      oldPasswordPlaceholder: 'Ingrese la contraseña actual',
      newPassword: 'Nueva contraseña',
      newPasswordPlaceholder: 'Ingrese la nueva contraseña',
      confirmPassword: 'Confirmación de contraseña',
      confirmPasswordPlaceholder: 'Ingrese la confirmación de contraseña',
    },
    feedback: {
      successTitle: 'Contraseña actualizada',
      successDescription: 'Contraseña actualizada con éxito.',
      errorTitle: 'Error',
      genericError: 'No fue posible actualizar la contraseña.',
      requiredFields: 'Complete todos los campos obligatorios.',
    },
  },
  patientLogin: {
    portalTitle: 'Portal del Paciente',
    heading: 'Acceda a su cuenta',
    subtitle: 'Siga sus citas e información',
    tenant: {
      label: 'Código de la clínica o empresa',
      extra:
        'Si no recibió un enlace directo, informe el código de la clínica o empresa.',
      placeholder: 'Ej.: clinica-centro',
      required: 'Informe el código de la clínica o empresa.',
      missing: 'Informe el código de la clínica o empresa para continuar.',
    },
    cpf: {
      label: 'CPF',
      placeholder: '000.000.000-00',
      required: 'Informe su CPF',
      invalid: 'El CPF debe tener 11 dígitos',
    },
    birthday: {
      label: 'Fecha de nacimiento',
      placeholder: 'DD/MM/AAAA',
      required: 'Informe su fecha de nacimiento',
    },
    submit: 'Entrar al portal',
    hint: 'Sus datos se utilizan solo para verificar su identidad.\nNo se requiere contraseña.',
    errorDefault: 'El CPF o la fecha de nacimiento son incorrectos.',
  },
  publicSchedule: {
    hero: {
      badge: 'Agendamiento en línea',
      title: 'Su clínica abierta para nuevas citas, sin llamadas y sin espera.',
      description:
        'Elija al profesional, el mejor horario y envíe su solicitud en pocos minutos. El pedido entra directo en el Sigeclin de la clínica.',
    },
    highlights: {
      flowLabel: 'Flujo',
      flowValue: 'El paciente elige el horario y lo envía solo',
      integrationLabel: 'Integración',
      integrationValue: 'Profesionales cargados de la clínica en tiempo real',
      statusLabel: 'Estado',
      statusValue: 'Solicitud creada con estado pendiente de confirmación',
    },
    metrics: {
      professionals: 'Profesionales',
      availableSlots: 'Horarios libres',
      conflicts: 'Conflictos del día',
    },
    summary: {
      title: 'Resumen de la solicitud',
      clinic: 'Clínica',
      clinicPlaceholder: 'Informe el código',
      professional: 'Profesional',
      professionalPlaceholder: 'Seleccione para ver agenda',
      date: 'Fecha',
      datePlaceholder: 'Elija una fecha',
      time: 'Horario',
      timePlaceholder: 'Defina el intervalo',
    },
    card: {
      title: 'Solicitar horario',
      subtitle:
        'Complete sus datos y seleccione la atención deseada para registrar el agendamiento público de la clínica.',
    },
    clinic: {
      label: 'Código de la clínica',
      placeholder: 'Ej.: sigeclin-demo',
      required: 'Informe el código de la clínica.',
      loadProfessionals: 'Cargar profesionales',
      missingTitle: 'Informe la clínica',
      missingDescription: 'Escriba el código de la clínica antes de continuar.',
      unavailableTitle: 'Clínica no informada',
      unavailableDescription:
        'Informe el código de la clínica para solicitar su horario.',
      loadErrorTitle: 'Error al cargar agenda',
      loadErrorDescription:
        'No fue posible cargar los profesionales de esta clínica.',
    },
    noProfessionals: {
      title: 'Ningún profesional disponible',
      description:
        'Esta clínica aún no tiene profesionales públicos activos para agendamiento.',
    },
    sections: {
      patientData: '1. Datos del paciente',
      appointment: '2. Elección de la atención',
    },
    fields: {
      patientName: 'Nombre completo',
      patientNamePlaceholder: 'Su nombre',
      patientNameRequired: 'Informe su nombre completo.',
      document: 'CPF o CNPJ',
      documentPlaceholder: 'Solo números o con formato',
      documentRequired: 'Informe su CPF o CNPJ.',
      birthday: 'Fecha de nacimiento',
      birthdayPlaceholder: 'Seleccione',
      birthdayRequired: 'Informe su fecha de nacimiento.',
      whatsapp: 'WhatsApp',
      whatsappPlaceholder: '(63) 99999-9999',
      whatsappRequired: 'Informe su WhatsApp.',
      whatsappInvalid: 'Informe un móvil válido con código de área.',
      email: 'Correo electrónico',
      emailPlaceholder: 'usted@ejemplo.com',
      emailInvalid: 'Informe un correo electrónico válido.',
      professional: 'Profesional',
      professionalPlaceholder: 'Seleccione',
      professionalRequired: 'Seleccione un profesional.',
      date: 'Fecha de la consulta',
      datePlaceholder: 'Seleccione',
      dateRequired: 'Elija la fecha deseada.',
      startTime: 'Horario',
      startTimeRequired: 'Elija el horario.',
      duration: 'Duración prevista',
      durationRequired: 'Elija la duración.',
      observation: 'Observación',
      observationPlaceholder:
        'Motivo de la consulta, preferencia de atención u observaciones importantes',
      privacy:
        'Autorizo el envío de mis datos para registro y contacto de este agendamiento.',
      privacyRequired: 'Necesita autorizar el envío de datos.',
    },
    availability: {
      title: 'Agenda del profesional en el día',
      loading: 'Verificando horarios ocupados...',
      reserved: 'Horario reservado',
      empty:
        'No se encontraron conflictos para esta fecha. Los horarios mostrados están libres.',
      placeholder:
        'Seleccione el profesional y la fecha para visualizar los horarios ya ocupados.',
      unavailableSuffix: 'indisponible',
      errorTitle: 'Error al consultar disponibilidad',
      errorDescription: 'No fue posible verificar los horarios ocupados.',
    },
    durationOptions: {
      minutes30: '30 minutos',
      minutes60: '60 minutos',
    },
    warnings: {
      slotUnavailableTitle: 'Horario indisponible',
      slotUnavailableDescription:
        'Ese horario entra en conflicto con otra cita del profesional. Elija otro intervalo.',
      slotOccupiedDescription:
        'Ese horario ya está ocupado para el profesional seleccionado.',
    },
    submit: {
      button: 'Solicitar agendamiento',
      successTitle: 'Agendamiento solicitado',
      successDescription: 'Su solicitud fue registrada con éxito.',
      errorTitle: 'Error al solicitar agendamiento',
      errorDescription: 'No fue posible completar su solicitud.',
    },
    validation: {
      title: 'Validación de disponibilidad',
      withConflicts:
        'Los horarios marcados como indisponibles ya entran en conflicto con la agenda existente del profesional.',
      withoutConflicts:
        'Los horarios disponibles ya consideran las citas actuales del profesional seleccionado.',
    },
    success: {
      pill: 'Solicitud registrada',
      title: 'Su horario ingresó en la agenda de la clínica.',
      description:
        'La solicitud fue guardada con éxito en Sigeclin. Si es necesario, la clínica podrá confirmar los detalles por WhatsApp u otro canal registrado.',
      patient: 'Paciente',
      professional: 'Profesional',
      start: 'Inicio',
      status: 'Estado',
      nextStepTitle: 'Próximo paso',
      nextStepDescription:
        'Puede cerrar esta página o enviar otra solicitud de horario si lo necesita.',
      newRequest: 'Hacer otro agendamiento',
    },
  },
  patientPortal: {
    popupBlocked:
      'No fue posible abrir la pantalla de impresión. Verifique el bloqueador de ventanas emergentes.',
    sessionExpired: 'Sesión expirada. Inicie sesión nuevamente.',
    loadError: 'No fue posible cargar los datos.',
    retryLogin: 'Iniciar sesión nuevamente',
    logout: 'Cerrar sesión',
    profile: {
      cpf: 'CPF',
      birthDate: 'Nacimiento',
    },
    tabs: {
      schedules: 'Citas',
      schedulesShort: 'Agenda',
      treatments: 'Tratamientos',
      treatmentsShort: 'Trat.',
      financials: 'Finanzas',
      financialsShort: 'Fin.',
      healthCertificates: 'Certificados',
      healthCertificatesShort: 'Cert.',
      prescriptions: 'Recetas',
      prescriptionsShort: 'Recetas',
      documents: 'Documentos',
      documentsShort: 'Docs',
      forms: 'Historias clínicas',
      formsShort: 'Hist.',
    },
    schedules: {
      empty: 'No tiene citas futuras.',
      status: {
        confirmed: 'Confirmado',
        pending: 'Pendiente',
        cancelled: 'Cancelado',
      },
    },
    financials: {
      empty: 'No se encontraron registros financieros.',
      open: 'Abierto',
      paid: 'Pagado',
      unknown: 'Desconocido',
      codePrefix: 'Nº',
      dueDate: 'Vencimiento',
      paymentDate: 'Pago',
    },
    healthCertificates: {
      empty: 'No se encontró ningún certificado.',
      title: 'Certificado',
      daysSingle: 'día',
      daysPlural: 'días',
      cid: 'CID',
      printCopy: 'Imprimir copia',
    },
    documents: {
      empty: 'No se encontró ningún documento.',
      prescriptionHeading: 'Receta',
      documentHeading: 'Documento',
      signed: 'Firmado',
      printCopy: 'Imprimir copia',
    },
    prescription: {
      digital: 'Receta digital',
      signed: 'Firmada digitalmente',
      validation: 'Validación',
      signedNotice: 'Esta receta fue firmada y tiene validez digital.',
      medicines: 'Medicamentos recetados',
      medicineFallback: 'Medicamento {{index}}',
      dosage: 'Dosis',
      frequency: 'Frecuencia',
      duration: 'Duración',
      instructions: 'Instrucciones',
      guidelines: 'Orientaciones',
      printable: 'Esta receta está disponible para impresión.',
    },
    treatments: {
      empty: 'No se encontró ningún tratamiento.',
      budget: 'Presupuesto',
      treatment: 'Tratamiento',
      approved: 'Aprobado',
      notApproved: 'No aprobado',
      professionalMissing: 'Profesional no informado',
      total: 'Total',
      progress: 'Progreso del tratamiento',
      procedures: 'Procedimientos',
      procedureFallback: 'Procedimiento',
      quantity: 'Cant.',
      noProcedures: 'No hay procedimientos registrados.',
      history: 'Historial de evoluciones',
      records: 'Registros',
      averageRank: 'Rango medio',
      lastRank: 'Último rango',
      chartTitle: 'Gráfico de evolución',
      rankDataset: 'Rango de evolución',
      rankTooltip: 'Rango',
      observationTooltip: 'Obs.',
      noObservation: 'No se informaron observaciones.',
      noHistory: 'No hay evolución registrada para este tratamiento.',
      status: {
        pending: 'Pendiente',
        inProgress: 'En curso',
        completed: 'Concluido',
        finished: 'Finalizado',
      },
      timeAt: 'a las',
      procedureLabel: 'Procedimiento',
      signed: 'Firmada',
    },
    forms: {
      empty: 'No se encontró ninguna historia clínica.',
      title: 'Historia clínica',
      code: 'Código',
      signed: 'Firmado',
      professional: 'Profesional',
      validationCode: 'Código de validación',
      infoSection: 'Información de la historia clínica',
      notInformed: 'No informado',
      noFields: 'No hay información completada en esta historia clínica.',
      evolutions: 'Evoluciones',
      evaluation: 'Evaluación',
      noObservation: 'No se informaron observaciones.',
      noEvolution: 'No hay evolución registrada para esta historia clínica.',
      timeAt: 'a las',
    },
  },
  dashboard: {
    error: {
      title: 'Error',
      financials: 'Error al listar cuentas financieras',
      schedules: 'Error al listar citas',
    },
    hero: {
      badge: 'Panel principal',
      greeting: 'Hola, {{name}}',
      subtitle:
        'Vea rápidamente los números más importantes de la clínica hoy.',
    },
    actions: {
      viewSchedule: 'Ver agenda',
      goFinancials: 'Ir a finanzas',
      quickTitle: 'Acciones rápidas',
      cashFlow: 'Flujo de caja',
      fullSchedule: 'Agenda completa',
      createExpense: 'Registrar gasto',
      details: 'Ver detalles',
      overdueAccounts: 'Ver cuentas',
      receivables: 'Ver cobros',
      report: 'Informe',
    },
    tooltips: {
      goSchedule: 'Ir a la agenda',
      whatsappSettings: 'Configuración de WhatsApp',
    },
    cards: {
      schedulesToday: 'CITAS DE HOY',
      schedulesDescription: 'Total de pacientes agendados',
      overduePayables: 'POR PAGAR (VENCIDAS)',
      pendingTitles: '{{count}} títulos pendientes',
      receivablesToday: 'POR COBRAR HOY',
      expectedInvoices: '{{count}} facturas previstas',
      whatsappMonth: 'WHATSAPP (MES)',
      whatsappDescription: 'Envíos registrados por la API de Meta',
      attention: 'Atención',
    },
  },
  schedulesPage: {
    error: {
      title: 'Error',
      listSchedules: 'Error al listar citas',
      listProfessionals: 'Error al listar profesionales',
      listHolidays: 'Error al listar feriados',
      listClients: 'Error al listar clientes',
      listStatus: 'Error al listar estados',
    },
    info: {
      holidayTitle: 'Feriado',
      confirmedAt: 'Confirmado el: {{date}}',
    },
    intro: {
      badge: 'Agenda',
      title: 'Agenda de la clínica',
      description:
        'Organice citas, vea confirmaciones y siga la ocupación del equipo en una sola vista.',
    },
    actions: {
      newSchedule: 'Nueva cita',
      reports: 'Informes',
      schedulesReport: 'Informe de citas',
    },
    filters: {
      professional: 'Profesional',
      professionalPlaceholder: 'Filtrar por profesional',
      allProfessionals: 'Todos los profesionales',
    },
    calendar: {
      today: 'Hoy',
      month: 'Mes',
      week: 'Semana',
      day: 'Día',
      list: 'Lista',
    },
  },
  scheduleConfirm: {
    loading: 'Cargando cita...',
    error: {
      title: 'Error',
      foundSuccess: '¡Cita encontrada con éxito!',
      invalidLink: 'Enlace inválido o vencido',
      missingParams: 'Enlace inválido: faltan parámetros',
      processConfirmation: 'Error al procesar la confirmación',
      invalidTitle: 'Enlace inválido o vencido',
      notFoundTitle: 'Cita no encontrada',
      notFoundDescription: 'Lo sentimos, no pudimos encontrar esta cita.',
    },
    confirmation: {
      successTitle: 'Éxito',
      confirmedSuccess: '¡Cita confirmada con éxito!',
      cancelledSuccess: '¡Cita rechazada con éxito!',
      confirmedToast: 'Su cita ha sido confirmada',
      cancelledToast: 'Su rechazo fue registrado',
      confirmedCardTitle: '¡Cita confirmada!',
      cancelledCardTitle: 'Cita cancelada',
      confirmedAt: 'Confirmado el: {{date}}',
      backHome: 'Volver al inicio',
    },
    hero: {
      title: 'Confirmación de cita',
      description:
        'Revise los detalles de su consulta y confirme para continuar',
    },
    details: {
      dateTime: 'Fecha y hora',
      fromTo: '{{date}} de {{start}} a {{end}}',
      daysUntilOne: 'Falta {{count}} día',
      daysUntilOther: 'Faltan {{count}} días',
      clinic: 'Clínica',
      professional: 'Profesional',
      patient: 'Paciente',
      phone: 'Teléfono',
      address: 'Dirección',
      observation: 'Observación',
    },
    decision: {
      title: '¿Cómo desea proceder?',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      cancelReason: 'Motivo de la cancelación',
      cancelReasonPlaceholder:
        'Ayúdenos a mejorar dejando el motivo de la cancelación...',
      confirmAction: 'Confirmar cita',
      cancelAction: 'Cancelar cita',
    },
    modal: {
      confirmTitle: 'Confirmar cita',
      cancelTitle: 'Cancelar cita',
      confirmOk: 'Sí, confirmar',
      cancelOk: 'Sí, cancelar',
      back: 'No, volver',
      confirmQuestion: '¿Confirma que desea programar esta consulta?',
      cancelQuestion: '¿Está seguro de que desea cancelar esta cita?',
      confirmDescription: 'Recibirá una confirmación por correo electrónico',
      cancelDescription:
        'La clínica recibirá una notificación de la cancelación',
    },
  },
  financialsPage: {
    toast: {
      errorTitle: 'Error',
      warningTitle: 'Aviso',
      listPayments: 'Error al listar formas de pago',
      selectAtLeastOne: 'Seleccione al menos una cuenta',
      removeCancelled: 'Quite las cuentas canceladas de la selección',
      selectPendingOnly: 'Seleccione solo cuentas pendientes para pagar',
      listAccounts: 'Error al listar cuentas',
    },
    status: {
      cancelled: 'Cancelado',
      received: 'Recibido',
      overdue: 'Atrasado',
      pending: 'Pendiente',
      open: 'Abierto',
      paid: 'Pagado',
      openPaid: 'Abierto/Pagado',
    },
    actions: {
      edit: 'Editar',
      pay: 'Registrar/Pagar',
      reverse: 'Revertir',
      receipt: 'Recibo',
      newEntry: 'Nuevo registro',
      cashRegister: 'Control de caja',
      quickSale: 'Venta rápida',
      paySelected: 'Registrar seleccionados',
      cancelSelected: 'Cancelar seleccionados',
      reports: 'Informes',
      cashFlow: 'Flujo de caja',
      dre: 'Estado de resultados',
      accountsPayable: 'Cuentas por pagar',
      accountsReceivable: 'Cuentas por cobrar',
      movements: 'Movimientos financieros',
      delinquency: 'Morosidad',
      advancedReports: 'Informes avanzados',
      commissionClosing: 'Cierre de comisiones',
      moreActions: 'Más acciones',
      back: 'Volver',
      clear: 'Limpiar',
      filter: 'Filtrar',
    },
    intro: {
      badge: 'Finanzas',
      title: 'Gestión financiera',
      description:
        'Siga ingresos, gastos y morosidad con filtros rápidos y una visión consolidada de los principales valores del período.',
    },
    filters: {
      searchPlaceholder: 'Buscar...',
      advanced: 'Filtros avanzados',
      typePlaceholder: 'Tipo',
      typeIncome: 'Ingreso',
      typeExpense: 'Gasto',
      statusPlaceholder: 'Estado',
      filterByPlaceholder: 'Filtrar por',
      dueDate: 'Vencimiento',
      paymentDate: 'Pago',
      competenceDate: 'Competencia',
    },
    summary: {
      confirmedReceived: 'Recibido (Confirmado)',
      pendingReceivable: 'Por cobrar (Pendiente)',
      paidExpenses: 'Pagado (Gastos)',
      pendingPayable: 'Por pagar (Pendiente)',
    },
    table: {
      id: 'ID',
      type: 'Tipo',
      clientCode: 'Cód.',
      clientSupplier: 'Cliente/Proveedor',
      dueDate: 'Vencimiento',
      paymentDate: 'Pago',
      value: 'Valor',
      paymentMethod: 'Forma de pago',
      status: 'Estado',
      income: 'INGRESO',
      expense: 'GASTO',
    },
    createEdit: {
      titleCreate: 'Nuevo registro financiero',
      titleEdit: 'Editar registro N.º {{code}}',
      description:
        'Registre ingresos y gastos con una estructura visual consistente y foco en la información principal del registro.',
      sections: {
        entryInfo: 'Información del Registro',
        financialDetails: 'Detalles Financieros',
        observations: 'Observaciones',
      },
      movementTypes: {
        income: 'Ingreso (Entrada)',
        expense: 'Gasto (Salida)',
      },
      fields: {
        movementType: 'Tipo de Movimiento',
        description: 'Descripción',
        descriptionPlaceholder: 'Ej: Alquiler, Venta mostrador...',
        client: 'Cliente',
        supplier: 'Proveedor',
        selectPlaceholder: 'Seleccione...',
        accountPlan: 'Plan de Cuentas',
        accountPlanPlaceholder: 'Clasificación...',
        value: 'Valor',
        dueDate: 'Vencimiento',
        paymentMethod: 'Forma de Pago',
        documentNumber: 'N.º Documento',
        installments: 'Cuotas',
        options: 'Opciones',
        repeatValue: 'Repetir Valor',
        splitValue: 'Dividir Valor',
        observationsPlaceholder: 'Detalles adicionales sobre este registro...',
      },
      actions: {
        create: 'Registrar Movimiento',
        save: 'Guardar Cambios',
      },
      toast: {
        loadDataError: 'Error al cargar datos',
        loadDependenciesError: 'Error al cargar dependencias',
        successTitle: 'Éxito',
        errorTitle: 'Error',
        warningTitle: 'Atención',
        created: 'Registro creado con éxito',
        updated: 'Registro actualizado',
        checkFields: 'Verifique los campos',
      },
      validation: {
        typeRequired: 'Tipo obligatorio',
        clientRequired: 'Cliente obligatorio',
        descriptionRequired: 'Descripción obligatoria',
        dueDateRequired: 'Fecha de vencimiento obligatoria',
        valueMin: 'El valor debe ser mayor que cero',
        valueRequired: 'Valor obligatorio',
        documentNumberRequired: 'Número de documento obligatorio',
      },
    },
  },
  statusFinancial: {
    open: 'Abierto',
    paid: 'Pagado',
    overdue: 'Vencido',
    cancelled: 'Cancelado',
  },
  statusItemTreatment: {
    inProgress: 'En curso',
    completed: 'Concluido',
    pending: 'Pendiente',
  },
  treatmentsPage: {
    toast: {
      errorTitle: 'Error',
      listError: 'Error al listar tratamientos',
    },
    actions: {
      refresh: 'Actualizar',
      create: 'Registrar',
      reports: 'Informes',
      production: 'Producción',
      treatments: 'Tratamientos',
      procedures: 'Procedimientos',
      moreActions: 'Más acciones',
      back: 'Volver',
      view: 'Ver',
      approveReject: 'Aprobar/Rechazar',
      edit: 'Editar',
      evolution: 'Evolución',
      print: 'Imprimir',
    },
    intro: {
      badge: 'Tratamientos',
      title: 'Presupuestos y tratamientos',
      description:
        'Siga aprobaciones, progreso de las atenciones y la evolución de los tratamientos en una sola vista.',
    },
    searchPlaceholder: 'Buscar...',
    stats: {
      total: 'Total',
      approved: 'Aprobados',
      pending: 'Pendientes',
      inProgress: 'En curso',
    },
    filters: {
      all: 'Todos',
      budgets: 'Presupuestos',
      treatments: 'Tratamientos',
    },
    table: {
      id: 'Id',
      type: 'Tipo',
      client: 'Cliente',
      professional: 'Profesional',
      total: 'Total',
      progress: 'Progreso',
      situation: 'Situación',
      signature: 'Firma',
      options: 'Opciones',
      typeTreatment: 'TRAT',
      typeBudget: 'PRES',
      approved: 'Aprobado',
      rejected: 'Rechazado',
      pending: 'Pendiente',
      signed: 'Firmado',
      unsigned: 'Sin firma',
    },
  },
  clientsPage: {
    toast: {
      errorTitle: 'Error',
      listError: 'Error al listar clientes',
    },
    intro: {
      badge: 'Registros',
      title: 'Clientes y proveedores',
      description:
        'Siga la base de registros de la clínica, busque rápidamente y acceda a los principales informes sin salir del listado.',
    },
    actions: {
      refresh: 'Actualizar',
      create: 'Registrar',
      clientsReport: 'Informe de clientes',
      birthdays: 'Cumpleaños',
    },
    table: {
      id: 'Id',
      type: 'Tipo',
      document: 'CPF/CNPJ',
      name: 'Razón social/Nombre',
      phone: 'Celular',
      status: 'Estado',
      options: 'Opciones',
      code: 'Código',
    },
  },
  proceduresPage: {
    toast: {
      errorTitle: 'Error',
      listError: 'Error al listar procedimientos',
    },
    intro: {
      badge: 'Registros',
      title: 'Procedimientos',
      description:
        'Gestione los procedimientos disponibles, revise precios y acceda rápidamente al registro y edición de los elementos.',
    },
    actions: {
      refresh: 'Actualizar',
      create: 'Registrar',
      edit: 'Editar',
    },
    table: {
      id: 'Id',
      description: 'Descripción',
      price: 'Precio',
      status: 'Estado',
      options: 'Opciones',
    },
    modal: {
      validation: {
        descriptionRequired: 'Descripción obligatoria',
        priceMin: 'El valor debe ser mayor que cero',
        priceRequired: 'Precio obligatorio',
        statusRequired: 'Estado obligatorio',
      },
      toast: {
        successTitle: 'Registrado',
        infoTitle: 'Actualizado',
        errorTitle: 'Error',
        blankFieldsTitle: 'Campos vacíos',
        createdDescription: 'Registrado con éxito.',
        updatedDescription: 'Datos actualizados con éxito.',
        createError: 'Error al registrar',
        editError: 'Error al editar.',
      },
      titleCreate: 'Registrar',
      titleEdit: 'Editar',
      fields: {
        description: 'Descripción',
        descriptionPlaceholder: 'Ingrese la descripción',
        price: 'Precio',
        pricePlaceholder: 'Ingrese el precio',
        active: 'Activo',
        dental: '¿Es odontológico?',
      },
    },
  },
  specialtiesModal: {
    validation: {
      descriptionRequired: 'Descripción obligatoria',
      statusRequired: 'Estado obligatorio',
    },
    toast: {
      successTitle: 'Registrado',
      infoTitle: 'Actualizado',
      errorTitle: 'Error',
      blankFieldsTitle: 'Campos vacíos',
      createdDescription: 'Registrado con éxito.',
      updatedDescription: 'Datos actualizados con éxito.',
      createError: 'Error al registrar.',
      editError: 'Error al actualizar.',
    },
    titleCreate: 'Registrar',
    titleEdit: 'Editar',
    fields: {
      description: 'Descripción',
      descriptionPlaceholder: 'Ingrese la descripción',
      active: 'Activo',
    },
  },
  covenantsModal: {
    validation: {
      descriptionRequired: 'Descripción obligatoria',
      statusRequired: 'Estado obligatorio',
    },
    toast: {
      successTitle: 'Registrado',
      infoTitle: 'Actualizado',
      errorTitle: 'Error',
      blankFieldsTitle: 'Campos vacíos',
      createdDescription: 'Registrado con éxito.',
      updatedDescription: 'Datos actualizados con éxito.',
      createError: 'Error al registrar.',
      editError: 'Error al editar.',
    },
    titleCreate: 'Registrar',
    titleEdit: 'Editar',
    fields: {
      description: 'Descripción',
      descriptionPlaceholder: 'Ingrese la descripción',
      active: 'Activo',
    },
  },
  addressModal: {
    validation: {
      cepRequired: 'Código postal obligatorio',
      streetRequired: 'Dirección obligatoria',
      neighborhoodRequired: 'Barrio obligatorio',
      cityRequired: 'Ciudad obligatoria',
      stateRequired: 'Estado obligatorio',
    },
    toast: {
      successTitle: 'Registrado',
      infoTitle: 'Actualizado',
      errorTitle: 'Error',
      blankFieldsTitle: 'Campos vacíos',
      cepNotFoundTitle: 'Código postal no encontrado',
      cepNotFoundDescription:
        'No fue posible encontrar el código postal informado.',
      createdDescription: 'Registrado con éxito.',
      updatedDescription: 'Datos actualizados con éxito.',
    },
    titleCreate: 'Registrar',
    titleEdit: 'Editar',
    fields: {
      cep: 'Código postal',
      cepPlaceholder: 'Código postal',
      street: 'Dirección',
      streetPlaceholder: 'Ingrese la dirección',
      number: 'Número',
      numberPlaceholder: 'Ingrese el número',
      neighborhood: 'Barrio',
      neighborhoodPlaceholder: 'Ingrese el barrio',
      complement: 'Complemento',
      complementPlaceholder: 'Ingrese el complemento',
      city: 'Ciudad',
      cityPlaceholder: 'Ingrese la ciudad',
      state: 'Estado',
      statePlaceholder: 'Ingrese el estado',
      active: 'Activo',
    },
  },
  productCategoriesModal: {
    validation: {
      descriptionRequired: 'Descripción obligatoria',
    },
    toast: {
      successTitle: 'Registrado',
      infoTitle: 'Actualizado',
      errorTitle: 'Error',
      blankFieldsTitle: 'Campos vacíos',
      createdDescription: 'Registrado con éxito.',
      updatedDescription: 'Datos actualizados con éxito.',
      createError: 'Error al registrar.',
      editError: 'Error al editar.',
    },
    titleCreate: 'Registrar',
    titleEdit: 'Editar',
    fields: {
      description: 'Descripción de la categoría',
      descriptionPlaceholder: 'Ingrese una descripción objetiva',
      descriptionHelp:
        'Esta descripción se usará para organizar los productos en el inventario.',
      status: 'Estado',
      activeDescription: 'Categoría activa para nuevos productos',
      inactiveDescription: 'Categoría inactiva',
    },
  },
  schedulesStatusModal: {
    validation: {
      descriptionRequired: 'Descripción obligatoria',
      colorRequired: 'Color obligatorio',
      statusRequired: 'Estado obligatorio',
    },
    toast: {
      successTitle: 'Registrado',
      infoTitle: 'Actualizado',
      errorTitle: 'Error',
      blankFieldsTitle: 'Campos vacíos',
      createdDescription: 'Registrado con éxito.',
      updatedDescription: 'Datos actualizados con éxito.',
      createError: 'Error al registrar.',
      editError: 'Error al editar.',
    },
    titleCreate: 'Registrar',
    titleEdit: 'Editar',
    fields: {
      description: 'Descripción',
      descriptionPlaceholder: 'Ingrese la descripción',
      color: 'Color',
      colorPlaceholder: 'Ingrese el color',
      active: 'Activo',
    },
  },
  guidesStatusModal: {
    validation: {
      descriptionRequired: 'Descripción obligatoria',
      colorRequired: 'Color obligatorio',
      statusRequired: 'Estado obligatorio',
    },
    toast: {
      successTitle: 'Registrado',
      infoTitle: 'Actualizado',
      errorTitle: 'Error',
      blankFieldsTitle: 'Campos vacíos',
      createdDescription: 'Registrado con éxito.',
      updatedDescription: 'Datos actualizados con éxito.',
      createError: 'Error al registrar.',
      editError: 'Error al editar.',
    },
    titleCreate: 'Registrar',
    titleEdit: 'Editar',
    fields: {
      description: 'Descripción',
      descriptionPlaceholder: 'Ingrese la descripción',
      color: 'Color',
      colorPlaceholder: 'Ingrese el color',
      active: 'Activo',
    },
  },
  financialPlansModal: {
    validation: {
      descriptionRequired: 'Descripción obligatoria',
      statusRequired: 'Estado obligatorio',
    },
    toast: {
      successTitle: 'Registrado',
      infoTitle: 'Actualizado',
      errorTitle: 'Error',
      blankFieldsTitle: 'Campos vacíos',
      createdDescription: 'Registrado con éxito.',
      updatedDescription: 'Datos actualizados con éxito.',
      createError: 'Error al registrar.',
      editError: 'Error al editar.',
    },
    titleCreate: 'Registrar',
    titleEdit: 'Editar',
    fields: {
      description: 'Descripción',
      descriptionPlaceholder: 'Ingrese la descripción',
      active: 'Activo',
    },
  },
  holidaysModal: {
    validation: {
      descriptionRequired: 'Descripción obligatoria',
      dayRequired: 'Día obligatorio',
      monthRequired: 'Mes obligatorio',
      statusRequired: 'Estado obligatorio',
    },
    toast: {
      successTitle: 'Registrado',
      infoTitle: 'Actualizado',
      errorTitle: 'Error',
      blankFieldsTitle: 'Campos vacíos',
      createdDescription: 'Registrado con éxito.',
      updatedDescription: 'Datos actualizados con éxito.',
      createError: 'Error al registrar.',
      editError: 'Error al editar.',
    },
    titleCreate: 'Registrar',
    titleEdit: 'Editar',
    fields: {
      description: 'Descripción',
      descriptionPlaceholder: 'Ingrese la descripción',
      day: 'Día',
      dayPlaceholder: 'Seleccione el día',
      month: 'Mes',
      monthPlaceholder: 'Seleccione el mes',
      active: 'Activo',
    },
    months: {
      january: 'Enero',
      february: 'Febrero',
      march: 'Marzo',
      april: 'Abril',
      may: 'Mayo',
      june: 'Junio',
      july: 'Julio',
      august: 'Agosto',
      september: 'Septiembre',
      october: 'Octubre',
      november: 'Noviembre',
      december: 'Diciembre',
    },
  },
  toSignature: {
    title: 'Autenticar firma digital',
    fields: {
      password: 'Contraseña de firma',
      passwordPlaceholder: 'Ingrese la contraseña de firma del profesional',
    },
    toast: {
      warningTitle: 'Aviso',
      errorTitle: 'Error',
      passwordRequired: 'Ingrese la contraseña de firma',
    },
  },
  productModal: {
    validation: {
      nameRequired: 'Descripción obligatoria',
      productTypeRequired: 'Tipo de producto obligatorio',
      salePriceMin: 'El precio de venta debe ser mayor que cero',
      salePriceRequired:
        'El precio de venta es obligatorio para productos vendibles',
      salePriceInvalid: 'Precio inválido',
      minimumInventoryMin: 'El stock mínimo debe ser mayor que cero',
      minimumInventoryRequired: 'El stock mínimo es obligatorio',
      maximumInventoryMin: 'El stock máximo debe ser mayor que cero',
      maximumInventoryRequired: 'El stock máximo es obligatorio',
    },
    toast: {
      successTitle: 'Registrado',
      infoTitle: 'Actualizado',
      errorTitle: 'Error',
      blankFieldsTitle: 'Campos vacíos',
      createdDescription: 'Registrado con éxito.',
      updatedDescription: 'Datos actualizados con éxito.',
      createError: 'Error al registrar.',
      editError: 'Error al editar.',
    },
    titleCreate: 'Registrar',
    titleEdit: 'Editar',
    productTypes: {
      supply: 'Insumo',
      retail: 'Producto para venta',
    },
    sections: {
      inventory: 'Control de inventario',
    },
    fields: {
      name: 'Nombre',
      namePlaceholder: 'Ingrese el nombre del producto',
      description: 'Descripción',
      descriptionPlaceholder:
        'Agregue una descripción corta para facilitar la identificación',
      category: 'Categoría del producto',
      categoryPlaceholder: 'Seleccione la categoría',
      productType: 'Tipo de producto',
      unity: 'Unidad',
      unityPlaceholder: 'Seleccione',
      salePrice: 'Precio base de venta',
      salePricePlaceholder: 'Ej: 49.90',
      salePriceDisabledPlaceholder: 'No aplica para insumos',
      minimumInventory: 'Stock mínimo',
      minimumInventoryPlaceholder: 'Ej: 10',
      maximumInventory: 'Stock máximo',
      maximumInventoryPlaceholder: 'Ej: 100',
      inventoryHelp: 'Informe los límites para alertas de reposición',
      inventoryRange: 'Rango configurado: {{min}} a {{max}}{{unity}}',
      productStatus: 'Estado del producto',
      activeDescription: 'Producto activo para movimientos',
      inactiveDescription: 'Producto inactivo',
    },
  },
  inventoryEntriesPage: {
    toast: {
      errorTitle: 'Error',
      listEntries: 'Error al listar entradas',
      listProducts: 'Error al listar productos',
    },
    intro: {
      badge: 'Inventario',
      title: 'Reposiciones del inventario',
      description:
        'Use esta pantalla cuando un producto ingresó en la clínica: compra, reposición, devolución o ajuste manual de cantidad.',
    },
    actions: {
      refresh: 'Actualizar',
      newEntry: 'Nueva entrada',
      view: 'Ver',
    },
    stats: {
      registeredEntries: 'Reposiciones registradas',
      purchasedValue: 'Valor comprado',
      receivedQuantity: 'Cantidad recibida',
      usedSuppliers: 'Proveedores utilizados',
    },
    table: {
      date: 'Fecha',
      product: 'Producto',
      source: 'Origen',
      receivedQuantity: 'Cant. recibida',
      unitPrice: 'Precio unitario',
      options: 'Opciones',
    },
  },
  modelsFormsCreateEdit: {
    validation: {
      titleRequired: 'Título obligatorio',
      missingInputs: 'Faltan los campos del formulario',
      inputTypeRequired: 'Tipo obligatorio',
      inputLabelRequired: 'Campo obligatorio',
    },
    toast: {
      infoTitle: 'Información',
      successTitle: 'Éxito',
      errorTitle: 'Error',
      blankFields: 'Campos vacíos',
      updated: 'Historia clínica actualizada con éxito',
      created: 'Historia clínica registrada con éxito',
      createError: 'Error al registrar',
      editError: 'Error al editar',
    },
    intro: {
      badge: 'Modelos',
      createTitle: 'Registrar modelo de historia clínica',
      editTitle: 'Editar modelo de historia clínica',
      description:
        'Configure modelos de historia clínica y sus campos con el shell visual compartido.',
    },
    fields: {
      title: 'Título',
      titlePlaceholder: 'Título de la historia clínica',
      description: 'Descripción',
      descriptionPlaceholder: 'Descripción de la historia clínica',
      active: 'Activo',
      inputs: 'Campos',
      addInput: 'Agregar campo',
    },
    inputModal: {
      validation: {
        noOptionsTitle: 'Sin opciones',
        noOptionsDescription: 'Se necesita al menos una opción',
        emptyOptionsTitle: 'Opción(es) sin valor',
        emptyOptionsDescription: 'Campo(s) de opción(es) sin valor',
      },
      toast: {
        successTitle: 'Éxito',
        infoTitle: 'Actualizado',
        errorTitle: 'Error',
        blankFields: 'Campos vacíos',
        created: 'Registrado con éxito.',
        updated: 'Actualizado con éxito.',
        createError: 'Error al registrar',
        editError: 'Error al editar.',
      },
      titleCreate: 'Registrar',
      titleEdit: 'Editar',
      fields: {
        type: 'Tipo de campo',
        typePlaceholder: 'Informe el tipo de campo',
        question: 'Texto de la pregunta',
        questionPlaceholder: 'Informe el texto',
        order: 'Orden de la pregunta',
        orderPlaceholder: 'Informe el orden del campo Ej: 1, 2, 3...',
        required: '¿Obligatorio?',
        active: 'Activo',
        options: 'Opciones',
        addOption: 'Agregar opción',
        optionValuePlaceholder: 'Valor',
      },
    },
  },
  modelsDocumentsCreateEdit: {
    validation: {
      titleRequired: 'Nombre obligatorio',
    },
    toast: {
      infoTitle: 'Actualizado',
      errorTitle: 'Error',
      blankFields: 'Campos vacíos',
      createdTitle: 'Registrado',
      created: 'Registrado con éxito.',
      copiedTitle: 'Copiado',
      copiedDescription: 'Palabra clave "{{keyword}}" copiada al portapapeles',
      updated: 'Datos actualizados con éxito.',
      createError: 'Error al registrar',
      editError: 'Error al editar',
    },
    intro: {
      badge: 'Modelos',
      createDocument: 'Registrar modelo de documento',
      editDocument: 'Editar modelo de documento',
      createPrescription: 'Registrar modelo de receta',
      editPrescription: 'Editar modelo de receta',
      prescriptionDescription:
        'Configure un modelo de receta electrónica con placeholders para los medicamentos, fecha y orientaciones.',
      documentDescription:
        'Configure modelos reutilizables de documentos dentro del estándar visual del sistema.',
    },
    status: {
      active: 'ACTIVO',
      inactive: 'INACTIVO',
    },
    sections: {
      basicInfo: 'Información básica',
      keywords: 'Palabras clave disponibles',
      content: 'Contenido del documento',
      modelStatus: 'Estado del modelo',
    },
    fields: {
      prescriptionTitle: 'Título de la receta',
      documentTitle: 'Título del documento',
      modelType: 'Tipo de modelo',
      text: 'Texto',
      activateModel: 'Activar modelo',
    },
    placeholders: {
      titleExample: 'Ej.: INFORME DE EVALUACIÓN',
    },
    tooltips: {
      modelName: 'Nombre que identifica este modelo',
      modelNameDescription:
        'Escriba un nombre descriptivo para este modelo (ej: INFORME DE EVALUACIÓN)',
      deactivateModel: 'Desactive para ocultar este modelo a los usuarios',
      copyKeyword: 'Copiar palabra clave',
    },
    options: {
      document: 'Documento',
      prescription: 'Receta electrónica',
    },
    instructions: {
      keywords:
        'Copie y pegue las palabras clave en el texto del modelo. Se reemplazarán automáticamente por los datos del cliente cuando se genere el documento.',
      importantTitle: 'Importante:',
      importantDescription:
        'Las palabras clave deben escribirse exactamente como se muestran arriba',
      content:
        'Escriba el texto del documento. Use las palabras clave de arriba para insertar datos dinámicos que se completarán automáticamente.',
    },
    keywords: {
      name: 'Nombre del cliente',
      cpf: 'CPF del cliente',
      birthDate: 'Fecha de nacimiento del cliente',
      phone: 'Nº de celular del cliente',
      gender: 'Sexo del cliente',
      maritalStatus: 'Estado civil del cliente',
      email: 'Correo electrónico del cliente',
      nationality: 'Nacionalidad del cliente',
      naturalness: 'Lugar de nacimiento del cliente',
      profession: 'Profesión del cliente',
      zipCode: 'Código postal de la dirección del cliente',
      street: 'Dirección del cliente',
      number: 'Número de la dirección del cliente',
      district: 'Barrio de la dirección del cliente',
      complement: 'Complemento de la dirección del cliente',
      city: 'Ciudad de la dirección del cliente',
      state: 'Estado de la dirección del cliente',
      prescriptionDate: 'Fecha de emisión de la receta',
      prescriptionItems: 'Lista de medicamentos recetados',
      prescriptionGuidelines: 'Orientaciones complementarias de la receta',
    },
    template: {
      patient: 'Paciente',
      date: 'Fecha',
    },
  },
  sendScheduleConfirmation: {
    defaultClientName: 'Cliente',
    messages: {
      copied: '¡Enlace copiado al portapapeles!',
      emailRequired: 'Informe una dirección de correo electrónico',
      emailSent: '¡Correo enviado con éxito!',
      emailError: 'Error al enviar el correo',
      phoneRequired: 'Informe un número de teléfono',
      whatsappSent: '¡Mensaje de WhatsApp enviado con éxito!',
      whatsappError: 'Error al enviar WhatsApp',
    },
    title: 'Enviar enlace de confirmación de cita',
    close: 'Cerrar',
    to: 'Para',
    sections: {
      link: 'Enlace de confirmación',
      email: 'Enviar por correo',
      whatsapp: 'Enviar por WhatsApp',
      info: 'Información importante:',
    },
    actions: {
      copyLink: 'Copiar enlace',
      sendEmail: 'Enviar correo',
      sending: 'Enviando...',
      sendWhatsapp: 'Enviar WhatsApp',
    },
    fields: {
      emailPlaceholder: 'Correo del cliente',
      phonePlaceholder: 'Teléfono del cliente (con código de país)',
    },
    hints: {
      expiry: 'Este enlace vence en 7 días',
      phoneFormat: 'Formato: +55 (99) 99999-9999',
    },
    infoList: {
      valid: 'El enlace es válido por 7 días',
      confirmOrCancel: 'El cliente puede confirmar o cancelar por el enlace',
      confirmationNotice:
        'Después de la confirmación, recibirá una notificación',
      singleUse: 'El enlace no puede reutilizarse',
    },
  },
  modelsFormsPage: {
    toast: {
      errorTitle: 'Error',
      listError: 'Error al listar historias clínicas',
    },
    intro: {
      badge: 'Modelos',
      title: 'Modelos de historias clínicas',
      description:
        'Mantenga los modelos clínicos organizados en una vista alineada con el nuevo estándar de las pantallas internas.',
    },
    actions: {
      refresh: 'Actualizar',
      create: 'Registrar',
      edit: 'Editar',
    },
    table: {
      title: 'Título',
      status: 'Estado',
      options: 'Opciones',
    },
  },
  modelsDocumentsPage: {
    toast: {
      errorTitle: 'Error',
      listError: 'Error al listar modelos',
    },
    intro: {
      badge: 'Modelos',
      titleDocuments: 'Modelos de documentos',
      titlePrescriptions: 'Modelos de recetas',
      descriptionDocuments:
        'Centralice los modelos usados por la clínica en un listado más claro y consistente con el resto de la interfaz.',
      descriptionPrescriptions:
        'Organice los modelos de receta electrónica con el mismo flujo de firma e impresión ya utilizado por el sistema.',
    },
    actions: {
      refresh: 'Actualizar',
      create: 'Registrar',
      createPrescription: 'Registrar receta',
      edit: 'Editar',
    },
    filters: {
      documents: 'Documentos',
      prescriptions: 'Recetas',
    },
    table: {
      index: '#',
      title: 'Título',
      status: 'Estado',
      options: 'Opciones',
    },
  },
  insertPayment: {
    toast: {
      errorTitle: 'Error',
      fillAllFields: 'Complete todos los campos',
    },
    installments: {
      single: '{{count}} vez',
      multiple: '{{count}} veces',
    },
    modal: {
      title: 'Insertar pago',
      ok: 'Insertar',
    },
    fields: {
      paymentMethod: 'Forma de pago',
      paymentMethodPlaceholder: 'Seleccione la forma de pago',
      value: 'Valor',
      installments: 'Cant. de cuotas',
      installmentsPlaceholder: 'Seleccione la cantidad de cuotas',
      dueDate: 'Fecha de vencimiento',
    },
  },
  treatmentProductsModal: {
    messages: {
      loadProductsError: 'Error al cargar productos',
      loadTreatmentProductsError: 'Error al cargar productos del tratamiento',
      addSuccess: 'Producto agregado con éxito',
      addError: 'Error al agregar producto',
      updateError: 'Error al actualizar producto',
      removeSuccess: 'Producto eliminado con éxito',
      removeError: 'Error al eliminar producto',
    },
    modal: {
      title: 'Productos del tratamiento {{suffix}}',
      dentalSuffix: 'Odontológico',
      close: 'Cerrar',
    },
    table: {
      product: 'Producto',
      quantity: 'Cantidad',
      unitPrice: 'Precio unitario',
      total: 'Total',
      actions: 'Acciones',
      notFound: 'Producto no encontrado',
    },
    addSection: {
      title: 'Agregar nuevo producto',
      helper: 'Seleccione un producto para agregar',
      placeholder: 'Busque por código o nombre',
      button: 'Agregar',
      allAdded: 'Todos los productos disponibles ya fueron agregados',
    },
    addedSection: {
      title: 'Productos agregados',
      empty: 'Ningún producto agregado',
      emptyHelper: 'Seleccione un producto arriba para comenzar',
      helper: 'Edite cantidad y precio según sea necesario',
    },
    summary: {
      totalProducts: 'Total de productos:',
      totalValue: 'Valor total:',
    },
    retail: {
      loadProductsError: 'Error al cargar productos para venta avulsa',
      selectProductWarning: 'Seleccione un producto para continuar',
      quantityWarning: 'Ingrese una cantidad mayor que cero',
      unitPriceWarning: 'El valor unitario no puede ser negativo',
      modalTitle: 'Productos avulsos de la venta',
      modalOk: 'Concluir',
      buildSaleTitle: 'Montar venta avulsa',
      product: 'Producto',
      productPlaceholder: 'Busque por código o nombre',
      quantity: 'Cantidad',
      unitPrice: 'Valor unitario',
      addButton: 'Agregar',
      helper:
        'Use esta área para productos vendidos en la atención, pero que no necesitan quedar vinculados clínicamente al protocolo del tratamiento. Solo aparecen aquí los ítems marcados como producto para venta.',
      itemsTitle: 'Ítems de la venta avulsa',
      empty: 'Ningún producto avulso agregado',
      productNotFound: 'Producto no encontrado',
      actions: 'Acciones',
      detachedItems: 'Ítems avulsos',
      projectedTotal: 'Total previsto',
    },
  },
  usersPage: {
    validation: {
      nameRequired: 'Nombre obligatorio',
      cpfRequired: 'CPF obligatorio',
      invalidCpf: 'cpf inválido',
      phoneRequired: 'Celular obligatorio',
      birthDateRequired: 'Fecha de nacimiento obligatoria',
      loginRequired: 'Login obligatorio',
      accessGroupRequired: 'Grupo de acceso obligatorio',
      passwordRequired: 'Contraseña obligatoria',
      passwordConfirmationRequired: 'Confirmación de contraseña obligatoria',
      passwordMismatch:
        'La contraseña no coincide con la contraseña de confirmación.',
    },
    toast: {
      errorTitle: 'Error',
      blankFields: 'Campos vacíos',
      listError: 'Error al listar planes de cuentas',
      listAccessGroupsError: 'Error al listar los grupos de acceso',
      updatedTitle: 'Usuario actualizado',
      updatedDescription: 'Datos del usuario actualizados con éxito.',
      createdTitle: 'Usuario registrado',
      createdDescription: 'Usuario registrado con éxito.',
      editError: 'Error al actualizar.',
      createError: 'Error al registrar',
    },
    intro: {
      badge: 'Registros',
      listTitle: 'Usuarios',
      listDescription:
        'Gestione cuentas internas, accesos y restablecimientos de contraseña con el mismo diseño usado en las demás pantallas administrativas.',
      createTitle: 'Registrar usuario',
      editTitle: 'Editar usuario',
      formDescription:
        'Defina datos personales, grupo de acceso y credenciales en una pantalla estandarizada con el resto del sistema.',
    },
    actions: {
      refresh: 'Actualizar',
      create: 'Registrar',
      edit: 'Editar',
      resetPassword: 'Restablecer contraseña',
    },
    table: {
      cpf: 'CPF',
      name: 'Nombre',
      birthDate: 'Nacimiento',
      login: 'Login',
      status: 'Estado',
      options: 'Opciones',
    },
    fields: {
      name: 'Nombre',
      namePlaceholder: 'Ingrese el nombre',
      cpf: 'CPF',
      cpfPlaceholder: 'Ingrese el CPF',
      birthDate: 'Fecha de nacimiento',
      accessGroup: 'Grupo de acceso',
      phone: 'Teléfono',
      phonePlaceholder: 'Ingrese el teléfono',
      loginEmail: 'Correo electrónico (Login)',
      password: 'Contraseña',
      passwordPlaceholder: 'Ingrese la contraseña',
      passwordConfirmation: 'Confirmación de contraseña',
      passwordConfirmationPlaceholder: 'Confirme su contraseña',
      active: 'Activo',
    },
    resetPassword: {
      modalTitle: '¿Restablecer contraseña?',
      confirmButton: 'Restablecer',
      description:
        '¿Desea restablecer la contraseña al valor predeterminado [1 a 6]?',
      successTitle: 'Éxito',
      successDescription: 'Contraseña restablecida con éxito',
      errorDescription: 'Error al restablecer la contraseña.',
    },
  },
  companiesPage: {
    toast: {
      errorTitle: 'Error',
      successTitle: 'Éxito',
      fetchCompaniesError: 'Error al obtener empresas.',
      fetchPlansError: 'Error al obtener planes globales.',
      saveConfigSuccess: '¡Estado actualizado con éxito!',
      createTenantSuccess: '¡Empresa registrada con éxito!',
      serverConnectionError: 'Error al conectar con el servidor',
      savePlanSuccess: '¡Plan guardado con éxito!',
      savePlanError: 'Error al guardar el plan.',
    },
    shared: {
      none: 'Ninguno',
      notAvailable: '-',
      currencyPrefix: '$',
    },
    permission: {
      checking: 'Verificando permisos...',
      deniedTitle: 'Acceso denegado',
      deniedDescription:
        'Esta es un área restringida para la gestión del sistema.',
      deniedHelper:
        'Solo el perfil administrador del tenant gerente tiene permiso de acceso.',
    },
    breadcrumb: {
      home: 'Inicio',
      current: 'Empresas',
    },
    header: {
      title: 'Gestión de Empresas (Tenants)',
    },
    summary: {
      total: 'Total de tenants',
      active: 'Tenants activos',
      blocked: 'Tenants bloqueados',
    },
    helperText:
      'Registre nuevos tenants y gestione los módulos y bloqueos por empresa.',
    actions: {
      back: 'Volver',
      refresh: 'Actualizar',
      newTenant: 'Nuevo Tenant',
      newPlan: 'Nuevo Plan',
      edit: 'Editar',
      configure: 'Configuraciones',
    },
    status: {
      tenant: {
        active: 'Activo',
        blocked: 'Bloqueado',
      },
      enabled: {
        active: 'Activo',
        inactive: 'Inactivo',
      },
      plan: {
        active: 'Activo',
        trial: 'Prueba',
        suspended: 'Suspendido',
        canceled: 'Cancelado',
      },
    },
    landing: {
      visible: 'Visible',
      hidden: 'Oculto',
    },
    legacyModules: {
      dental: 'Odontológico',
      medical: 'Médico',
      aesthetics: 'Estética',
    },
    modules: {
      agenda: 'Control de Agenda',
      clientes: 'Registro de Clientes',
      financeiro: 'Finanzas',
      documentos: 'Documentos',
      assinatura_digital: 'Firma Digital',
      tratamentos: 'Tratamientos Clínicos',
      odontologico: 'Odontología',
      atestados_medicos: 'Certificados Médicos',
      formularios: 'Formularios',
      guias: 'Guías',
      convenios: 'Convenios y Terminologías',
      estetica: 'Estética',
      estoque: 'Inventario',
      produtos: 'Productos',
      usuarios: 'Usuarios',
      permissoes: 'Permisos y Grupos de Acceso',
      profissionais: 'Profesionales',
      especialidades: 'Especialidades',
      procedimentos: 'Procedimientos',
      whatsapp: 'WhatsApp',
      email: 'Correo electrónico',
      empresa: 'Datos de la Empresa',
    },
    autoConfirmationChannels: {
      both: 'WhatsApp y correo electrónico',
      whatsapp: 'Solo WhatsApp',
      email: 'Solo correo electrónico',
      disabled: 'Desactivado',
    },
    table: {
      plans: {
        title: 'Planes Globales',
        empty: 'Ningún plan global registrado.',
        limitSummary:
          '{{users}} usuarios / {{professionals}} profesionales / {{clients}} clientes',
        columns: {
          code: 'Código',
          name: 'Nombre',
          monthlyFee: 'Mensualidad',
          limits: 'Límites',
          status: 'Estado',
          landing: 'Landing',
          actions: 'Acciones',
        },
      },
      tenants: {
        title: 'Empresas Registradas',
        empty: 'Ninguna empresa registrada.',
        columns: {
          name: 'Nombre',
          status: 'Estado',
          activeModules: 'Módulos Activos',
          plan: 'Plan',
          dueDate: 'Vencimiento (días)',
          createdAt: 'Fecha de Creación',
          actions: 'Acciones',
        },
      },
    },
    createTenantModal: {
      title: 'Registrar Tenant',
      helper:
        'Este nombre se utilizará para crear el esquema aislado de la empresa.',
      fields: {
        identifier: 'Identificador del tenant',
        identifierPlaceholder: 'Ej.: clinica_central',
      },
      validation: {
        required: 'Informe el nombre del tenant.',
        alreadyExists: 'Ya existe una clínica con este identificador.',
        createError: 'Error al registrar tenant.',
      },
    },
    planModal: {
      titleCreate: 'Nuevo Plan',
      titleEdit: 'Editar Plan {{name}}',
      saveButton: 'Guardar Plan',
      sections: {
        landing: 'Información de la Landing',
        allowedModules: 'Módulos habilitados por este plan',
      },
      fields: {
        code: 'Código:',
        name: 'Nombre:',
        description: 'Descripción:',
        landingSubtitle: 'Subtítulo del plan:',
        landingPrice: 'Precio mostrado en la landing:',
        landingPricePlaceholder: 'Ej.: A consultar',
        landingFrequency: 'Frecuencia mostrada:',
        landingFrequencyPlaceholder: 'Ej.: /mes',
        landingHighlight: 'Destacado de la tarjeta:',
        landingHighlightPlaceholder: 'Ej.: Más elegido',
        landingSortOrder: 'Orden en la landing:',
        landingFeatures: 'Lista de beneficios de la landing:',
        landingFeaturesPlaceholder: 'Un elemento por línea',
        monthlyPriceCents: 'Mensualidad en centavos:',
        maxUsers: 'Máximo de Usuarios:',
        maxProfessionals: 'Máximo de Profesionales:',
        maxClients: 'Máximo de Clientes:',
        defaultDueDate: 'Vencimiento predeterminado:',
      },
      checkboxes: {
        landingVisible: 'Mostrar este plan en la landing page',
        recommendedDental: 'Odontológico por defecto',
        recommendedMedical: 'Médico por defecto',
        recommendedAesthetics: 'Estética por defecto',
        recommendedShowClientCode: 'Mostrar código del cliente por defecto',
        status: 'Plan activo',
      },
      allowedModulesHelper:
        'Marque los módulos a los que el cliente tendrá acceso al contratar este plan.',
    },
    configModal: {
      title: 'Configuraciones de {{name}}',
      loadError: 'Error al cargar configuraciones.',
      sections: {
        planManager: 'Administrador del Plan',
        overrides: 'Overrides del Tenant',
        moduleOverrides: 'Excepción de Módulos',
      },
      fields: {
        autoConfirmationChannel: 'Canal automático de confirmación de cita:',
        planSuggestions: 'Sugerencias de Plan:',
        planSuggestionsPlaceholder: 'Seleccione un plan sugerido',
        planStatus: 'Estado del Plan:',
        planStartedAt: 'Inicio del Plan (YYYY-MM-DD):',
        planEndsAt: 'Fin del Plan (YYYY-MM-DD):',
        maxUsers: 'Límite de Usuarios:',
        maxProfessionals: 'Límite de Profesionales:',
        maxClients: 'Límite de Clientes:',
        dueDate: 'Días para Vencimiento:',
      },
      checkboxes: {
        blockClient: 'Bloquear Cliente',
        dentalModule: 'Módulo Odontológico',
        medicalModule: 'Módulo Médico',
        aestheticsModule: 'Módulo de Estética',
        showClientCode: 'Mostrar Código del Cliente',
        customizeModules: 'Personalizar módulos para este cliente',
      },
      planCard: {
        noPlanSelected: 'Ningún plan seleccionado',
        code: 'Código: {{code}}',
        monthlyFee: 'Mensualidad: {{amount}}',
        basePlan:
          'Plan base: {{users}} usuarios, {{professionals}} profesionales, {{clients}} clientes',
        descriptionEmpty: 'Seleccione un plan para ver los detalles.',
      },
      overridesHelper:
        'Si cambia algún valor a continuación, pasará a aplicarse solo a este cliente sin alterar el plan global.',
      moduleOverridesHelper:
        'Déjelo en blanco para heredar los módulos del plan. Marque aquí solo si desea habilitar o restringir módulos específicos únicamente para este cliente.',
    },
  },
  dentalPage: {
    intro: {
      badge: 'Odontología',
      title: 'Presupuestos y tratamientos odontológicos',
      description:
        'Centraliza aprobaciones, avance clínico y firmas de los tratamientos odontológicos en una sola vista.',
    },
    actions: {
      refresh: 'Actualizar',
      create: 'Crear',
      moreActions: 'Más acciones',
      back: 'Volver',
      view: 'Ver',
      approveOrReject: 'Aprobar/Rechazar',
      edit: 'Editar',
      evolution: 'Evolución',
      print: 'Imprimir',
    },
    toast: {
      errorTitle: 'Error',
      listError: 'Error al listar tratamientos',
    },
    stats: {
      total: 'Total',
      approved: 'Aprobados',
      pending: 'Pendientes',
      inProgress: 'En progreso',
    },
    filters: {
      all: 'Todos',
      budgets: 'Presupuestos',
      treatments: 'Tratamientos',
    },
    searchPlaceholder: 'Buscar...',
    table: {
      id: 'Id',
      type: 'Tipo',
      typeTreatmentShort: 'TRAT',
      typeBudgetShort: 'PRES',
      client: 'Cliente',
      professional: 'Profesional',
      total: 'Total',
      progress: 'Progreso',
      status: 'Situación',
      signature: 'Firma',
      actions: 'Opciones',
    },
    status: {
      approved: 'Aprobado',
      rejected: 'Rechazado',
      pending: 'Pendiente',
    },
    signature: {
      signed: 'Firmado',
      notSigned: 'Sin firma',
    },
  },
  dentalCreateEdit: {
    intro: {
      createTreatmentTitle: 'Crear tratamiento',
      createBudgetTitle: 'Crear presupuesto',
      editTreatmentTitle: 'Editar tratamiento',
      editBudgetTitle: 'Editar presupuesto',
      codeSuffix: 'N.º {{code}}',
    },
    types: {
      treatment: 'Tratamiento',
      budget: 'Presupuesto',
    },
    sections: {
      basicInfo: 'Información básica',
      odontogram: 'Odontograma dental',
      procedures: 'Procedimientos odontológicos',
    },
    fields: {
      procedureType: 'Tipo de procedimiento',
      patient: 'Paciente',
      professional: 'Profesional',
    },
    tooltips: {
      procedureType:
        'Seleccione si es un tratamiento completo o un presupuesto',
      patient: 'Seleccione el paciente responsable',
      professional: 'Seleccione el profesional responsable',
    },
    placeholders: {
      patient: 'Seleccione el paciente',
      professional: 'Seleccione el profesional',
    },
    actions: {
      edit: 'Editar',
      remove: 'Eliminar',
      back: 'Volver',
    },
    emptyState: {
      title: 'Aún no se agregó ningún procedimiento odontológico',
      description:
        'Haga clic en los dientes del odontograma de arriba para comenzar',
    },
    table: {
      tooth: 'Diente',
      face: 'Cara',
      currentState: 'Estado actual',
      procedure: 'Procedimiento',
      unitValue: 'Valor unit.',
      discount: 'Descuento',
      total: 'Total',
      actions: 'Acciones',
    },
    summary: {
      subtotal: 'Subtotal de procedimientos:',
      discount: 'Descuento total:',
      totalToPay: 'Total a pagar:',
    },
    savedNotice: {
      title: 'Registro guardado:',
      description:
        'Este {{type}} odontológico se guardó con éxito (N.º {{code}}). Puede verlo en detalle o imprimirlo usando la opción de impresión.',
    },
    toast: {
      successTitle: 'Éxito',
      savedTitle: 'Tratamiento guardado',
      errorTitle: 'Error',
      blankFieldsTitle: 'Campos en blanco',
      createdDescription: '{{type}} registrado con éxito',
      approvalRedirectWarning:
        'El tratamiento se guardó, pero no fue posible abrir automáticamente la pantalla de aprobación.',
      createError: 'Error al registrar.',
      loadError: 'Error al consultar.',
      listClientsError: 'Error al listar los clientes.',
      listProfessionalsError: 'Error al listar los profesionales',
    },
    odontogram: {
      invalidCondition: 'ID inválido',
      conditions: {
        amalgam: 'Amalgama',
        caries: 'Caries',
        endodontics: 'Endodoncia',
        missing: 'Ausente',
        resin: 'Resina',
        implant: 'Implante',
        sealant: 'Sellante',
        crown: 'Corona',
        other: 'Otros',
        clear: 'Limpiar',
      },
    },
    procedureModal: {
      toast: {
        successTitle: 'Éxito',
        infoTitle: 'Actualizado',
        errorTitle: 'Error',
        insertedDescription: 'Procedimiento insertado',
        updatedDescription: 'Procedimiento actualizado',
        insertError: 'Error al insertar procedimiento',
        editError: 'Error al editar procedimiento',
      },
      titleCreate: 'Insertar procedimiento',
      titleEdit: 'Editar procedimiento',
      fields: {
        procedure: 'Procedimiento',
        procedurePlaceholder: 'Seleccione el procedimiento',
        price: 'Precio',
        toothNumber: 'Número del diente',
        toothFace: 'Cara del diente',
        currentState: 'Estado actual',
      },
    },
  },
  odontogramRender: {
    title: 'Odontograma',
    instructions:
      'Haga clic en las caras de los dientes para aplicar condiciones odontológicas',
    arches: {
      upperAdult: 'Arcada superior - Adulto',
      upperChild: 'Arcada superior - Infantil',
      lowerChild: 'Arcada inferior - Infantil',
      lowerAdult: 'Arcada inferior - Adulto',
    },
    toast: {
      selectConditionTitle: 'Aviso',
      selectConditionDescription: 'Seleccione una condición para el diente.',
    },
    conditions: {
      amalgam: 'Amalgama',
      caries: 'Caries',
      endodontics: 'Endodoncia',
      missing: 'Ausente',
      resin: 'Resina',
      implant: 'Implante',
      sealant: 'Sellante',
      crown: 'Corona',
      other: 'Otros',
    },
  },
  modelsHealthCertificatesPage: {
    intro: {
      badge: 'Plantillas',
      title: 'Plantillas de certificados',
      description:
        'Gestione las plantillas de certificados con el mismo estándar visual aplicado a las demás pantallas de configuración y registro.',
    },
    actions: {
      refresh: 'Actualizar',
      create: 'Registrar',
      edit: 'Editar',
    },
    table: {
      index: '#',
      title: 'Título',
      status: 'Estado',
      options: 'Opciones',
    },
    toast: {
      errorTitle: 'Error',
      listError: 'Error al listar las plantillas',
    },
  },
  modelsHealthCertificatesCreateEdit: {
    intro: {
      badge: 'Plantillas',
      createTitle: 'Registrar plantilla de certificado',
      editTitle: 'Editar plantilla de certificado',
      description:
        'Estructure plantillas de certificados reutilizables siguiendo el estándar visual interno del sistema.',
    },
    sections: {
      basicInfo: 'Información básica',
      keywords: 'Palabras clave disponibles',
      content: 'Contenido del certificado',
      status: 'Estado de la plantilla',
    },
    instructions: {
      basicInfo:
        'Defina un título claro para identificar esta plantilla de certificado en la lista y en el flujo de registro.',
      keywords:
        'Copie y pegue las palabras clave en el texto del certificado. Se reemplazarán automáticamente por los datos del paciente cuando se genere el certificado.',
      content:
        'Escriba el texto del certificado. Use las palabras clave anteriores para insertar datos dinámicos que se completarán automáticamente.',
      status:
        'Desactive la plantilla para ocultarla a los usuarios sin perder el contenido configurado.',
    },
    fields: {
      title: 'Título del certificado',
      text: 'Texto',
      status: 'Activar plantilla',
    },
    placeholders: {
      title: 'Ej.: CERTIFICADO DE ASISTENCIA',
      titleHelp:
        'Ingrese un nombre descriptivo para esta plantilla (ej.: CERTIFICADO DE ASISTENCIA)',
    },
    tooltips: {
      title: 'Nombre que identifica esta plantilla de certificado',
      status: 'Desactive para ocultar esta plantilla de los usuarios',
    },
    status: {
      active: 'ACTIVO',
      inactive: 'INACTIVO',
    },
    toast: {
      errorTitle: 'Error',
      blankFieldsTitle: 'Campos en blanco',
      createdTitle: 'Registrado',
      createdDescription: 'Registrado con éxito.',
      updatedTitle: 'Actualizado',
      updatedDescription: 'Datos actualizados con éxito.',
      createError: 'Error al registrar la plantilla de certificado',
      editError: 'Error al editar la plantilla de certificado',
    },
    validation: {
      titleRequired: 'Nombre obligatorio',
    },
  },
  patientHealthCertificatePrint: {
    error: {
      load: 'No fue posible cargar el certificado para impresión.',
      notFound: 'Certificado no encontrado.',
    },
    actions: {
      backToPanel: 'Volver al panel',
    },
  },
  healthCertificateCreateEdit: {
    intro: {
      badge: 'Documentos',
      createTitle: 'Crear certificado',
      editTitle: 'Editar certificado',
      description:
        'Monte el certificado con plantilla, paciente, profesional y firma dentro del nuevo estándar visual de la aplicación.',
    },
    sections: {
      selection: 'Seleccionar plantilla y personas',
      appointmentInfo: 'Información de la atención',
      keywords: 'Palabras clave disponibles',
      content: 'Contenido del certificado',
    },
    instructions: {
      selection:
        'Seleccione la plantilla del certificado, el paciente y el profesional responsable. La plantilla cargará automáticamente el texto del certificado.',
      appointmentInfo:
        'Complete los horarios, la fecha y la duración de la atención. El código CID es opcional.',
      keywords:
        'Copie y pegue las palabras clave en el texto del certificado. Se reemplazarán automáticamente por los datos completados cuando se genere el certificado.',
      content:
        'Escriba el contenido del certificado. Use las palabras clave anteriores para insertar datos dinámicos que se completarán automáticamente con la información de la atención.',
    },
    fields: {
      model: 'Plantilla de certificado',
      patient: 'Paciente',
      professional: 'Profesional',
      startTime: 'Hora inicial',
      endTime: 'Hora final',
      date: 'Fecha de la atención',
      quantityDays: 'Cantidad de días',
      cid: 'Código CID (Opcional)',
      text: 'Texto del certificado',
    },
    placeholders: {
      model: 'Plantilla de certificado',
      patient: 'Paciente',
      professional: 'Profesional',
      cid: 'Ej.: J06 - Infección del tracto respiratorio superior',
    },
    tooltips: {
      model: 'Seleccione la plantilla del certificado',
      patient: 'Seleccione el paciente responsable del certificado',
      professional: 'Seleccione el profesional responsable',
      startTime: 'Hora de inicio de la atención',
      endTime: 'Hora de finalización de la atención',
      date: 'Fecha en que ocurrió la atención',
      quantityDays: 'Número de días del tratamiento/certificado',
      cid: 'Clasificación Internacional de Enfermedades (ej.: J06)',
    },
    keywords: {
      patientName: 'Nombre del paciente',
      patientCpf: 'CPF del paciente',
      daysCount: 'Cantidad de días del tratamiento',
      appointmentDate: 'Fecha de la atención',
      startTime: 'Hora de inicio de la atención',
      endTime: 'Hora de finalización de la atención',
      cid: 'Código CID (Clasificación Internacional de Enfermedades)',
    },
    warning: {
      title: 'Importante:',
      descriptionStart:
        'Las palabras clave deben escribirse exactamente como se muestran arriba (con llaves',
      descriptionEnd: 'y sin espacios).',
    },
    actions: {
      copyKeyword: 'Copiar palabra clave',
      back: 'Volver',
    },
    toast: {
      errorTitle: 'Error',
      blankFieldsTitle: 'Campos en blanco',
      createdTitle: 'Registrado',
      createdDescription: 'Registrado con éxito.',
      updatedTitle: 'Actualizado',
      updatedDescription: 'Datos actualizados con éxito.',
      createError: 'Error al registrar',
      editError: 'Error al editar',
      listProfessionalsError: 'Error al listar los profesionales',
      listModelsError: 'Error al listar las plantillas de certificados',
      keywordCopiedTitle: 'Copiado',
      keywordCopiedDescription:
        'Palabra clave "{{keyword}}" copiada al portapapeles',
    },
    validation: {
      startTimeRequired: 'La hora inicial es obligatoria',
      endTimeRequired: 'La hora final es obligatoria',
      futureDate: 'La fecha no puede ser futura',
      dateRequired: 'La fecha de la atención es obligatoria',
      clientRequired: 'El cliente es obligatorio',
      professionalRequired: 'El profesional es obligatorio',
      modelRequired: 'La plantilla del certificado es obligatoria',
      textRequired: 'El campo de texto es obligatorio',
    },
  },
  scheduleConfirmationMessageModal: {
    title: 'Enviar confirmación de cita',
    description: 'Enviar confirmación a {{clientName}}. Cita: {{date}}',
    actions: {
      sendWhatsapp: 'Enviar por WhatsApp',
      sendSms: 'Enviar por SMS',
    },
    channels: {
      whatsapp: 'WhatsApp',
      sms: 'SMS',
    },
    toast: {
      successTitle: 'Éxito',
      successDescription: '¡Mensaje por {{channel}} enviado con éxito!',
      errorTitle: 'Error',
      errorDescription: 'Error al enviar el mensaje.',
    },
    sendConfirmationModal: {
      title: 'Enviar Confirmación de Cita - {{name}}',
      close: 'Cerrar',
      tabs: {
        email: 'Email',
        whatsapp: 'WhatsApp',
      },
      linkCard: {
        title: 'Link de Confirmación',
        copy: 'Copiar Link',
        copiedTitle: 'Link copiado',
        copiedDescription: '¡Link de confirmación copiado al portapapeles!',
        expires: 'Este link vence en 7 días',
      },
      fields: {
        email: 'Dirección de Email',
        emailPlaceholder: 'cliente@ejemplo.com',
        phone: 'Número de Teléfono',
        phonePlaceholder: '+55 (11) 99999-9999',
        phoneHelp: 'Use el formato: +55 (DDD) 9XXXX-XXXX',
      },
      actions: {
        sendEmail: 'Enviar Email',
        sendEmailLoading: 'Enviando...',
        sendWhatsapp: 'Enviar WhatsApp',
        sendWhatsappLoading: 'Enviando...',
      },
      loading: 'Generando link de confirmación...',
      info: 'El cliente recibirá un link para confirmar o cancelar su cita. El link vence en 7 días y solo puede utilizarse una vez.',
      toast: {
        errorTitle: 'Error',
        successTitle: 'Éxito',
        tokenError: 'Error al generar token de confirmación',
        emailRequired: 'Ingrese una dirección de email',
        emailSent: '¡Email de confirmación enviado con éxito!',
        emailError: 'Error al enviar email',
        phoneRequired: 'Ingrese un número de teléfono',
        whatsappSent: '¡Mensaje de WhatsApp enviado con éxito!',
        whatsappError: 'Error al enviar WhatsApp',
      },
    },
  },
  upload: {
    defaultLabel: 'Subir firma en PNG',
  },
} as const;

export default locale;
